import { getEvento, update } from "../index";
import { Subcriptores as Subs } from '../../../Suscripciones';
export default function Subcriptores() {
    const p = getEvento();
    return <Subs s={p.suscriptores} u={update} />
}